// src/i18n/es/index.js

// Importar traducciones modulares - Fix de imports
import { zones } from './zones';
import { tagTypes } from './tagTypes';
import lockerTypes from './lockerTypes';
import hotels from './hotels';
import groups from './groups';
import hmis from './hmis';
import lockerControllers from './lockerControllers';
import lockers from './lockers';
import { lockerAssignments } from './lockerAssignments';
import common from './common';
import dashboard from './dashboard';
import users from './users';
import auth from './auth';
import tags from './tags';
import hmiSimulator from './hmiSimulator';
import hmiStaff from './hmiStaff';

const es = {
  ra: {
    action: {
      save: 'Guardar',
      saving: 'Guardando...',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      refresh: 'Actualizar',
      export: 'Exportar',
      list: 'Listar',
      show: 'Ver',
      menu: 'Menú',
      back: 'Volver',
      add_filter: 'Añadir filtro',
      confirm: 'Confirmar',
      more: 'Más opciones',
      clear_input_value: 'Limpiar campo',
      close: 'Cerrar',
      add: 'Añadir',
      sort: 'Ordenar',
      none: 'Ninguno'
    },
    validation: {
      required: 'Este campo es obligatorio',
    },
    navigation: {
      no_results: 'No se encontraron resultados',
      loading: 'Cargando',
      page_rows_per_page: 'Filas por página:',
      page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
      page_out_of_boundaries: 'Página %{page} fuera de límites',
      page_out_from_end: 'No se puede ir más allá de la última página',
      page_out_from_begin: 'No se puede ir antes de la página 1',
      page_empty: 'Sin registros',
      next: 'Siguiente',
      prev: 'Anterior',
      page_info: '%{from}-%{to} de %{count}',
      page_rows_per_page_all: 'Todas',
      // Claves adicionales que React Admin v5 podría usar
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
      page_range: '%{from}-%{to} de %{count}',
      displayed_records: '%{from}-%{to} of %{count}',
    },
    pagination: {
      page_info: '%{from}-%{to} de %{count}',
      page_info_simple: 'Página %{page}',
      labeled_page_info: '%{from}-%{to} de %{count}',
    },
    page: {
      not_found: 'Página no encontrada',
      error: 'Se ha producido un error',
      dashboard: 'Panel de Control',
      list: 'Lista',
      create: 'Crear',
      edit: 'Editar',
    },
    message: {
      not_found: 'El recurso solicitado no fue encontrado',
      error: 'Se ha producido un error. Por favor, inténtelo de nuevo más tarde',
      delete_title: 'Confirmar eliminación',
      delete_content: '¿Está seguro de que desea eliminar este elemento?',
      invalid_form: 'El formulario contiene errores. Por favor, revise los campos',
    },
    notification: {
      deleted: 'Elemento eliminado',
    },
    auth: {
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      username: 'Usuario',
      password: 'Contraseña',
      logging_in: 'Iniciando sesión...',
      sign_in_error: 'Error al iniciar sesión. Verifique sus credenciales.',
    },
    configurable: {
      customize: 'Personalizar',
    },
  },
  fields: {
    hotel: 'Hotel',
    zone: 'Zona',
    name: 'Nombre',
    description: 'Descripción',
    status: 'Estado',
    active: 'Activo',
    type: 'Tipo',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    city: 'Ciudad',
    country: 'País',
    createdAt: 'Fecha de creación',
    updatedAt: 'Última actualización',
    lastSeenAt: 'Última conexión',
    isOnline: 'En línea',
  },
  common,
  resources: {
    lockers,
    locker_assignments: lockerAssignments,
    users: users,
    hotels: hotels,
    groups: groups,
    tags: tags,
    settings: {
      name: 'Configuración |||| Configuraciones',
    },
    tag_types: {
      name: 'Tipo de ID |||| Tipos de IDs',
    },
    locker_controllers: lockerControllers,
    hmis,
    locker_types: {
      name: 'Tipo de Taquilla |||| Tipos de Taquillas',
    },
    hmi_simulator: {
      name: 'Simulador |||| Simuladores',
    },
    // Versiones con guiones para compatibilidad con React Admin
    'tag-types': tagTypes,
    'locker-controllers': lockerControllers,
    'locker-types': lockerTypes,
    'locker-assignments': lockerAssignments,
    'hmi-simulator': {
      name: 'Simulador |||| Simuladores',
    },
    'hmi-staff': hmiStaff,
    zones: zones,
    tagTypes: tagTypes,
    dashboard: dashboard,
    // Grouped pages
    adminOptions: {
      name: 'Opciones Admin',
      tabs: {
        groups: 'Grupos',
        hotels: 'Hoteles',
        tag_types: 'Tipos de ID',
        locker_types: 'Tipos de Taquilla',
        system: 'Sistema',
      },
      help: {
        title: 'Opciones de Administración',
        description: 'Gestione los elementos básicos de configuración del sistema.',
        feature_groups: 'Gestión de grupos de hoteles',
        feature_hotels: 'Configuración de hoteles y sus propiedades',
        feature_tag_types: 'Tipos de identificación para acceso a taquillas',
        feature_locker_types: 'Configuración de tipos de taquilla disponibles',
      },
    },
    devices: {
      name: 'Dispositivos',
      tabs: {
        controllers: 'Controladores',
        hmis: 'Dispositivos HMI',
        staff: 'Personal HMI',
      },
      help: {
        title: 'Dispositivos',
        description: 'Gestione los controladores, terminales HMI y personal del sistema.',
        feature_controllers: 'Controladores de taquillas y su configuración de red',
        feature_hmis: 'Terminales HMI y su configuración',
        feature_staff: 'Personal HMI y sus códigos PIN de acceso',
      },
    },
  },
  dashboard,
  users,
  auth,
  hmiSimulator,
  shell: {
    menu: {
      groups: {
        general: 'General',
        operation: 'Operación',
        administration: 'Administración',
        tools: 'Herramientas',
      },
    },
  },
  user: {
    profile: 'Perfil',
    settings: 'Configuración',
    change_password: 'Cambiar contraseña',
  },
  pages: {
    login: {
      subtitle: 'Inicie sesión para comenzar',
      login_button: 'Iniciar Sesión',
      forgot_password: '¿Olvidó su contraseña?',
    },
    forgot_password: {
      title: 'Recuperar Contraseña',
      subtitle: 'Ingrese su correo electrónico y le enviaremos un enlace para restablecer su contraseña',
      email_label: 'Correo Electrónico',
      submit_button: 'Enviar enlace de recuperación',
      sending: 'Enviando...',
      back_to_login: 'Volver al inicio de sesión',
      email_sent: 'Correo enviado correctamente',
      success_message: 'Si el correo electrónico existe en nuestro sistema, recibirá un enlace para restablecer su contraseña en breve.',
      error: 'Ocurrió un error al procesar su solicitud. Por favor, inténtelo nuevamente.',
    },
    reset_password: {
      title: 'Restablecer Contraseña',
      new_password: 'Nueva Contraseña',
      confirm_password: 'Confirmar Contraseña',
      submit_button: 'Restablecer Contraseña',
      resetting: 'Restableciendo...',
      back_to_login: 'Volver al inicio de sesión',
      success: 'Contraseña restablecida correctamente',
      success_message: 'Su contraseña ha sido restablecida correctamente. Será redirigido al inicio de sesión en unos momentos.',
      redirecting: 'Redirigiendo al inicio de sesión...',
      error: 'Ocurrió un error al restablecer su contraseña. Por favor, inténtelo nuevamente.',
      passwords_dont_match: 'Las contraseñas no coinciden',
      password_too_short: 'La contraseña debe tener al menos 6 caracteres',
      no_token: 'No se proporcionó un token válido',
      invalid_token: 'El enlace de recuperación no es válido o ha expirado',
      validation_error: 'Error al validar el token',
      validating: 'Validando enlace...',
    },
    dashboard: {
      no_devices: 'No se han encontrado resultados',
      no_devices_description: 'No hay datos disponibles en este momento',
    },
  },
};

export default es;